import type { App } from "vue";

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? "";

interface ReportPayload {
  message: string;
  source: "web";
  stack?: string;
  url?: string;
  userAgent?: string;
}

let isInstalled = false;

function _send(payload: ReportPayload) {
  void fetch(`${apiBaseUrl}/api/client-errors`, {
    body: JSON.stringify(payload),
    credentials: apiBaseUrl ? "include" : "same-origin",
    headers: {
      "content-type": "application/json",
    },
    keepalive: true,
    method: "POST",
  }).catch(() => {});
}

function _reportError(error: unknown, info?: string) {
  if (error instanceof Error) {
    _send({
      message: info ? `${error.message} (${info})` : error.message,
      source: "web",
      stack: error.stack,
      url: typeof window !== "undefined" ? window.location.href : undefined,
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
    });
    return;
  }
  const message = typeof error === "string" ? error : "Unknown error";
  _send({
    message: info ? `${message} (${info})` : message,
    source: "web",
    url: typeof window !== "undefined" ? window.location.href : undefined,
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : undefined,
  });
}

function _onError(event: ErrorEvent) {
  _reportError(event.error ?? event.message);
}

function _onUnhandledRejection(event: PromiseRejectionEvent) {
  _reportError(event.reason);
}

export function installVueErrorHandler(app: App) {
  app.config.errorHandler = (error, _instance, info) => {
    _reportError(error, info);
    if (typeof console !== "undefined") {
      console.error(error);
    }
  };
}

export function useErrorReporter() {
  if (isInstalled || typeof window === "undefined") {
    return;
  }
  isInstalled = true;
  window.addEventListener("error", _onError);
  window.addEventListener("unhandledrejection", _onUnhandledRejection);
}
